/**
 * As parcelas que já têm fatura eletrónica emitida.
 *
 * ─── PORQUE EXISTE DOS DOIS LADOS ───────────────────────────────────────────
 *
 * O servidor tem a mesma regra, em `helpers/parcelasIntocaveis.mjs`, e é ele
 * que manda: ninguém contorna uma guarda do servidor mexendo no ecrã.
 *
 * Esta existe só para a pessoa saber ANTES de preencher. Um desconto recusado
 * depois de se escolher o valor, de se carregar em gravar e de se esperar pela
 * resposta é um erro que já custou trabalho a quem o levou.
 *
 * ─── UMA FTE PRENDE COMO DINHEIRO RECEBIDO ──────────────────────────────────
 *
 * A fatura já foi entregue à DNRE e já está na mão do cliente, com um valor
 * escrito. Mudar a parcela por baixo dela deixa o documento fiscal a dizer uma
 * coisa e a conta a dizer outra.
 *
 * O desconto PARCIAL continua a poder fazer-se — distribui-se pelas parcelas
 * livres. O que não se pode é isentar por inteiro, que obriga a mexer em
 * todas.
 */

export const parcelasComFte = (parcelas) =>
  (parcelas || []).filter((p) => p.documentoEletronico);

/**
 * A frase para o ecrã. Nomeia as parcelas pelo «2/3» que a pessoa vê na lista
 * — um id não lhe diz nada e obriga-a a adivinhar qual é a linha.
 */
export const mensagemParcelasComFte = (parcelas, acao) => {
  const nomes = parcelas.map((p) => p.nrParcela || "?").join(", ");
  const uma = parcelas.length === 1;

  return (
    `Não é possível ${acao}: ${uma ? "a parcela" : "as parcelas"} ${nomes} ` +
    `já ${uma ? "tem" : "têm"} fatura eletrónica emitida. ` +
    "Anule-a com uma nota de crédito antes de mudar o valor."
  );
};
